<template>
  <div>
    <!-- Loading State -->
    <div v-if="isLoading" class="flex justify-center py-12">
      <div class="animate-spin rounded-full h-8 w-8 border-2 border-border border-t-cosmicPurple"></div>
    </div>

    <!-- Error State -->
    <div v-else-if="error" class="px-6 py-10 text-center space-y-2">
      <p class="text-sm text-muted-foreground">{{ error }}</p>
      <button
        @click="$emit('retry')"
        class="text-xs font-medium text-cosmicPurple hover:underline"
      >
        Try again
      </button>
    </div>

    <!-- No Payments -->
    <div v-else-if="!hasPayments" class="flex flex-col items-center px-6 py-12 text-center gap-2">
      <CreditCard class="w-8 h-8 text-gray-300 mb-1" />
      <p class="text-sm font-medium text-gray-900">No Billing History</p>
      <p class="text-sm text-muted-foreground">Your payment history will appear here once you make your first payment.</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CreditCard } from 'lucide-vue-next'

interface Props {
  isLoading: boolean
  error: string | null
  hasPayments: boolean
}

interface Emits {
  (e: 'retry'): void
}

defineProps<Props>()
defineEmits<Emits>()
</script>
